module.exports = __webpack_public_path__ + "media/images/lb/364-952a9efc19260b03a397ba5cb40c0b6a.svg";